import { ReactNode } from 'react';
import { Navigate } from 'react-router';

import { ROUTES } from '@/app/routes/enums';

import { useAuth } from './hooks/useAuth';

type GuestOnlyRouteProps = {
  children: ReactNode;
  redirectTo?: string;
};

/**
 * Route wrapper for pages that should only be accessible to guests (not logged in)
 * Examples: Login page, signup page, forgot password, etc.
 *
 * If user is already authenticated, redirects them away
 */
export const GuestOnlyRoute = ({
  children,
  redirectTo = ROUTES.POLICY_LIST,
}: GuestOnlyRouteProps) => {
  const { isAuthenticated } = useAuth();

  // If authenticated, redirect to policy list
  if (isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  // Not authenticated, show the page
  return <>{children}</>;
};
